@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

$error-alert-box-height: 100px;

.errorAlert {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: $error-alert-box-height;
}
